import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { ErudaProvider } from "@/components/eruda";
import MiniKitProvider from "./minikit-provider";
import "./i18n/config";
import "./index.css";
import { Toaster } from "sonner";
import HomeLayout from "./layout/home-layout";
import { BuyChest } from "./pages/buy-chest";
import Homepage from "./pages/home";
import { CampaignPage } from "./pages/campaign";
import { CampaignDetail } from "./pages/campaign-detail";

function NotFoundComponent() {
  if (window.eggsvault?.PageNotFound) {
    return <window.eggsvault.PageNotFound />;
  }

  return <div>Page Not Found</div>;
}

function App() {
  return (
    <MiniKitProvider>
      <ErudaProvider>
        <Routes>
          <Route
            path="/"
            element={
              <HomeLayout>
                <Homepage />
              </HomeLayout>
            }
          >
            <Route index element={<></>} />
            <Route path="/buy-chest" element={<BuyChest />} />
          </Route>
          <Route path="campaign" element={<Outlet />}>
            <Route index element={<CampaignPage />} />
            <Route path=":id" element={<CampaignDetail />} />
          </Route>
          {/* <Route path="*" element={<NotFoundComponent />} /> */}
          <Route path="*" element={<Navigate to={"/"} />} />
        </Routes>
        <Toaster position="top-center" />
      </ErudaProvider>
    </MiniKitProvider>
  );
}

export default App;
